import { Pipe, PipeTransform } from '@angular/core';
import { isString } from 'lodash-es';

@Pipe({
  name: 'temperatureLevelModeName',
})
export class TemperatureLevelModeNamePipe implements PipeTransform {
  transform(val: string): string {
    if (val !== null && val !== undefined && isString(val)) {
      const parts = val.split('.');

      return parts[parts.length - 2];
    }

    return '';
  }
}
